import classNames from "classnames"
import { ExpandLess, ExpandMore, SquaredMinus } from "components/LEGACY/styled-components/Icons"
import { parseProductGroupImageURL, parseProductGroupName } from "components/orderPage/functions/products"
import IconButton from "components/utils/IconButton"
import { useProductGroup } from "hooks/firestore/simple/useProductGroup"
import Image from "next/image"

interface SelectedProductProps {
  productId: string
  removeProduct: (id: string) => void
  moveUp: (id: string) => void
  moveDown: (id: string) => void
  first: boolean
  last: boolean
}
function SelectedProduct({ productId, removeProduct, moveUp, moveDown, first, last }: SelectedProductProps) {
  const pg = useProductGroup(productId)

  if (!pg) return <></>

  const imgSrc = parseProductGroupImageURL(pg)?.url
  console.log(imgSrc)

  const name = parseProductGroupName(pg)

  return (
    <>
      <style jsx>{`
        .productGroupSelection {
          outline: none;
          padding: 0.25rem;
          /* width: 100%; */
          display: grid;
          background: transparent;
          border: 1px solid var(--dark);
          margin: 0.25rem;
          border-radius: 5px;
          align-items: center;
          grid-template-columns: auto 1fr auto;
          cursor: pointer;
        }
        .name {
          margin: 0 0.5rem;
          font-size: 1rem;
          text-align: left;
        }
        .image {
          height: 35px;
          width: 35px;
          object-fit: cover;
          background: var(--light);
          border-radius: 5px;
          overflow: hidden;
        }
      `}</style>
      <div className="productGroupSelection" style={{ cursor: "default" }}>
        <div className="image">
          {imgSrc && <Image width="35" height="35" className="image" src={imgSrc} alt="Artikelbild" />}
        </div>
        <div className="name">{name}</div>
        <div style={{ display: "flex" }}>
          <IconButton
            icon={<ExpandLess size="24" color="darkgrey" />}
            disabled={first}
            onClick={() => moveUp(productId)}
          />
          <IconButton
            icon={<ExpandMore size="24" color="darkgrey" />}
            disabled={last}
            onClick={() => moveDown(productId)}
          />
          <IconButton icon={<SquaredMinus size="24" color="darkgrey" />} onClick={() => removeProduct(productId)} />
        </div>
      </div>
    </>
  )
}

interface SelectedProductsProps {
  productIds: string[]
  setProductIds: (v: string[]) => void
  disabled: boolean
}
export default function SelectedProducts({ productIds, setProductIds, disabled }: SelectedProductsProps) {
  const removeProduct = (id: string) => {
    if (disabled) return
    return setProductIds(productIds.filter(pId => pId !== id))
  }
  const moveUp = (id: string) => {
    if (disabled) return

    const index = productIds.indexOf(id)
    const newArray = [...productIds]
    newArray[index] = productIds[index - 1]
    newArray[index - 1] = productIds[index]
    setProductIds(newArray)
  }
  const moveDown = (id: string) => {
    if (disabled) return
    const index = productIds.indexOf(id)
    const newArray = [...productIds]
    newArray[index] = productIds[index + 1]
    newArray[index + 1] = productIds[index]
    setProductIds(newArray)
  }

  return (
    <>
      <style jsx>{`
        .selectedProductsContainer {
          display: flex;
          flex-direction: column;
        }
        .selectedProductsContainer.disabled {
          cursor: not-allowed;
          opacity: 0.7;
        }
        h6 {
          color: currentColor;
        }
      `}</style>
      <div className={classNames("selectedProductsContainer", { disabled: disabled })}>
        <h6>
          {productIds.length === 0
            ? "Wähle ein bis fünf Produkte aus, die im Newsletter beworben werden sollen"
            : `Gewählte Produkte (${productIds.length} gewählt)`}
        </h6>

        {productIds.map((productId, index) => {
          return (
            <SelectedProduct
              key={productId}
              {...{
                productId,
                removeProduct,
                moveUp,
                moveDown,
                first: index === 0,
                last: index === productIds.length - 1,
              }}
            />
          )
        })}
      </div>
    </>
  )
}
